/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      h1: "h1",
      p: "p",
      strong: "strong",
      br: "br",
      a: "a",
      h2: "h2",
      ul: "ul",
      li: "li",
      hr: "hr"
    }, props.components);
    return _jsxs(_Fragment, {
      children: [_jsx(_components.h1, {
        children: "Podmínky užití webového rozhraní"
      }), "\n", _jsxs(_components.p, {
        children: ["Nacházíte se na webovém rozhraní ", _jsx(_components.strong, {
          children: "www.artinvestmentgallery.com"
        }), " (dále jen „", _jsx(_components.strong, {
          children: "webové rozhraní"
        }), "“), které provozuje společnost:"]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Shania, a.s."
        }), ", se sídlem Příkop 843/4, Zábrdovice, 602 00 Brno ", _jsx(_components.br, {}), "\n", "IČ: 28199308 ", _jsx(_components.br, {}), "\n", "DIČ: CZ28199308 ", _jsx(_components.br, {}), "\n", "zapsaná v obchodním rejstříku u Krajského soudu v Brně pod sp. zn. B 7778 ", _jsx(_components.br, {}), "\n", "adresa pro doručování: Pavlovova 1169/54, 700 30 Ostrava-Zábřeh ", _jsx(_components.br, {}), "\n", "kontaktní e-mail: ", _jsx(_components.a, {
          href: "mailto:info@shaniagroup.com",
          children: "info@shaniagroup.com"
        })]
      }), "\n", _jsxs(_components.p, {
        children: ["(dále jen „", _jsx(_components.strong, {
          children: "provozovatel"
        }), "“ nebo „", _jsx(_components.strong, {
          children: "my"
        }), "“)"]
      }), "\n", _jsx(_components.p, {
        children: "Vezměte prosím na vědomí, že bez ohledu na to, zda prostřednictvím webového rozhraní využíváte našich služeb nebo jej pouze navštěvujete, je nutné se řídit dále uvedenými pravidly, která vymezují a upřesňují podmínky užívání všech funkčních součástí webového rozhraní."
      }), "\n", _jsx(_components.h2, {
        children: "1. Funkce webového rozhraní – aukční síň"
      }), "\n", _jsxs(_components.p, {
        children: ["1.1. Webové rozhraní slouží zejména pro konání internetových aukcí, prodej zboží a služeb. „", _jsx(_components.strong, {
          children: "Aukční nabídkou"
        }), "“ se rozumí prezentace aukčního zboží, které je předmětem internetové aukce."]
      }), "\n", _jsx(_components.p, {
        children: "1.2. Zveřejňování aukčních nabídek a využívání některých služeb se řídí Všeobecnými obchodními podmínkami pro poskytování služeb. Koupě zboží se řídí Všeobecnými obchodními podmínkami pro prodej zboží. Podmínky konání aukcí a účasti na nich se řídí Řádem aukcí."
      }), "\n", _jsx(_components.p, {
        children: "1.3. Prohlížet aukční nabídky mohou i neregistrovaní uživatelé webového rozhraní."
      }), "\n", _jsx(_components.h2, {
        children: "2. Registrace a uživatelský účet"
      }), "\n", _jsxs(_components.p, {
        children: ["2.1. ", _jsx(_components.strong, {
          children: "Pro využití všech funkcí webového rozhraní, zejména pro účast na aukci, musíte být registrováni."
        }), " Registrovat se můžete prostřednictvím registračního formuláře dostupného na webovém rozhraní. Pro registraci je nutné vyplnit požadované údaje a zvolit si heslo. Registrací je založen uživatelský účet. Podmínkou registrace je souhlas s Všeobecnými obchodními podmínkami. Registrací vzniká smlouva mezi provozovatelem a účastníkem, který tímto vyjadřuje souhlas s podmínkami užití webového rozhraní."]
      }), "\n", _jsxs(_components.p, {
        children: ["2.2. Pro přístup do uživatelského účtu je potřeba uživatelské jméno a heslo. ", _jsx(_components.strong, {
          children: "Přístupové údaje do uživatelského účtu uchovávejte v tajnosti. Neneseme odpovědnost za případné zneužití uživatelského účtu třetí osobou."
        })]
      }), "\n", _jsxs(_components.p, {
        children: ["2.3. Informace uváděné při registraci musí být pravdivé a úplné. ", _jsx(_components.strong, {
          children: "Účet, při jehož založení byly použity nepravdivé nebo neúplné údaje, můžeme bez náhrady zrušit"
        }), ". V případě změn ve vašich údajích je třeba provést jejich bezodkladnou úpravu v uživatelském účtu."]
      }), "\n", _jsx(_components.p, {
        children: "2.4. Pro dokončení registrace je nutné ověřit vaši identitu prostřednictvím poskytovatele ověření, společnosti Veriff. Pro ověření vaší identity stiskněte na webovém rozhraní tlačítko „Ověřit profil“ a poté postupujte dle uvedených pokynů."
      }), "\n", _jsx(_components.p, {
        children: "2.5. Prostřednictvím uživatelského účtu lze především objednávat některé služby, účastnit se aukcí a provádět správu uživatelského účtu. Případné další funkce uživatelského účtu jsou uvedeny na webovém rozhraní."
      }), "\n", _jsxs(_components.p, {
        children: ["2.6. ", _jsx(_components.strong, {
          children: "Vezměte na vědomí, že máme právo váš uživatelský účet bez náhrady zrušit, pokud prostřednictvím vašeho účtu dochází k porušování dobrých mravů, platných právních předpisů České republiky, Všeobecných obchodních podmínek pro poskytování služeb, Všeobecných obchodních podmínek pro prodej zboží, Řádu aukcí nebo těchto podmínek užití."
        })]
      }), "\n", _jsx(_components.h2, {
        children: "3. Ochrana osobních údajů"
      }), "\n", _jsx(_components.p, {
        children: "Přiregistraci na webovém rozhraní nebo při objednávce našeho zboží nebo služeb nám poskytujete některé vaše osobní údaje. Dále při užívání webového rozhraní dochází k získávání, uchovávání a zpracovávání dalších údajů, k nimž máme přístup."
      }), "\n", _jsxs(_components.p, {
        children: ["Ochrana osobních údajů je pro nás velice důležitá. Při nakládání s osobními údaji proto postupujeme v souladu s právním řádem České republiky, zejména se zákonem č. 101/2000 Sb., o ochraně osobních údajů, ve znění pozdějších předpisů (dále jen „", _jsx(_components.strong, {
          children: "ZOOÚ"
        }), "“)."]
      }), "\n", _jsxs(_components.p, {
        children: ["3.1. ", _jsx(_components.strong, {
          children: "Čím se řídíme při nakládání s osobními údaji?"
        })]
      }), "\n", _jsxs(_components.p, {
        children: ["Při nakládání s osobními údaji postupujeme v souladu s právním řádem České republiky a přímo použitelnými předpisy Evropské unie, zejména s nařízením Evropského parlamentu a Rady (EU) 2016/679 ze dne 27. dubna 2016 o ochraně fyzických osob v souvislosti se zpracováním osobních údajů a o volném pohybu těchto údajů a o zrušení směrnice 95/46/ES (dále jen „", _jsx(_components.strong, {
          children: "nařízení"
        }), "“), zákonem č. 110/2019 Sb., o zpracování osobních údajů, v platném znění, zákonem č. 480/2004 Sb., o některých službách informační společnosti a o změně některých zákonů, ve znění pozdějších předpisů, a zákonem č. 127/2005 Sb., o elektronických komunikacích a o změně některých souvisejících zákonů (zákon o elektronických komunikacích), ve znění pozdějších předpisů."]
      }), "\n", _jsxs(_components.p, {
        children: ["3.2. ", _jsx(_components.strong, {
          children: "Co jsou osobní údaje?"
        })]
      }), "\n", _jsx(_components.p, {
        children: "Osobními údaji se rozumí veškeré informace, které identifikují nebo mohou identifikovat konkrétní fyzickou osobu. Osobními údaji jsou zejména (avšak nikoliv výlučně):"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["\n", _jsxs(_components.p, {
            children: [_jsx(_components.strong, {
              children: "identifikační údaje"
            }), ", jako např. jméno a příjmení, identifikační číslo, daňové identifikační číslo, datum narození, pohlaví, přihlašovací jméno do uživatelského účtu;"]
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsxs(_components.p, {
            children: [_jsx(_components.strong, {
              children: "kontaktní údaje"
            }), ", jako např. adresa bydliště (nebo doručovací adresa), telefonní číslo, e-mailová adresa;"]
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsxs(_components.p, {
            children: [_jsx(_components.strong, {
              children: "další údaje"
            }), ", jako např. informace získané pomocí souborů cookies, IP adresa (síťový identifikátor) včetně typu prohlížeče, zařízení a operačního systému, doby a počtu přístupů na webové rozhraní a další obdobné informace."]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsx(_components.h2, {
        children: "4. Získávání a využívání osobních údajů"
      }), "\n", _jsxs(_components.p, {
        children: ["4.1. ", _jsx(_components.strong, {
          children: "Jak získáváme vaše osobní údaje?"
        })]
      }), "\n", _jsxs(_components.p, {
        children: ["Své osobní údaje nám poskytujete zejména při vyplnění objednávky (event. v rámci kontaktního formuláře), případně při zřízení uživatelského účtu. ", _jsx(_components.strong, {
          children: "Pokud dojde k jakékoliv změně vašich osobních údajů, informujte nás o tom, prosím."
        })]
      }), "\n", _jsx(_components.p, {
        children: "Při návštěvě a užívání webového rozhraní může dále docházet k získávání a ukládání některých osobních údajů prostřednictvím souborů cookies. Více o souborech cookies se dočtete v článku 5 těchto Zásad."
      }), "\n", _jsxs(_components.p, {
        children: ["4.2. ", _jsx(_components.strong, {
          children: "Na jakém základě a pro jaké účely zpracováváme vaše osobní údaje?"
        })]
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["\n", _jsxs(_components.p, {
            children: ["Osobní údaje zadané ", _jsx(_components.strong, {
              children: "při poptávání"
            }), " (zejména prostřednictvím kontaktního formuláře) ", _jsx(_components.strong, {
              children: "a objednávání zboží či služeb"
            }), " můžeme bez vašeho výslovného souhlasu zpracovávat na základě a za účelem ", _jsx(_components.strong, {
              children: "uzavření"
            }), " a ", _jsx(_components.strong, {
              children: "plnění smlouvy"
            }), ", tedy za účelem dodání zboží nebo poskytnutí služby. Dále můžeme tyto údaje zpracovávat na základě a za účelem ", _jsx(_components.strong, {
              children: "splnění našich zákonem stanovených povinností"
            }), " (zejména evidenční povinnosti, archivace daňových dokladů apod.) a na základě našeho oprávněného zájmu pro účely ", _jsx(_components.strong, {
              children: "ochrany našich právních nároků"
            }), "."]
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsxs(_components.p, {
            children: ["Osobní údaje zadané ", _jsx(_components.strong, {
              children: "při založení uživatelského účtu"
            }), " můžeme bez vašeho výslovného souhlasu zpracovávat na základě plnění smlouvy a výlučně za účelem ", _jsx(_components.strong, {
              children: "umožnění přístupu, správy a vedení uživatelského účtu"
            }), "."]
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsxs(_components.p, {
            children: ["Vaši e-mailovou adresu ", _jsx(_components.strong, {
              children: "jsme oprávněni bez vašeho výslovného souhlasu"
            }), " využít na základě našeho oprávněného zájmu pro ", _jsx(_components.strong, {
              children: "zasílání obchodních sdělení týkajících se našeho zboží nebo služeb obdobných těm, které jste si od nás objednali"
            }), ". Zasílání obchodních sdělení můžete kdykoliv (i v rámci objednávání zboží či služeb) odmítnout."]
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsxs(_components.p, {
            children: ["Pokud nám k tomu potvrzením na webovém rozhraní dáte ", _jsx(_components.strong, {
              children: "souhlas"
            }), ", můžeme vaše osobní údaje zadané na webovém rozhraní, zejména při vyplnění objednávky nebo při založení uživatelského účtu, zpracovávat za účelem zasílání ", _jsx(_components.strong, {
              children: "obchodních sdělení"
            }), " a ", _jsx(_components.strong, {
              children: "přímého marketingu"
            }), ", případně za dalšími účely, se kterými jste výslovně souhlasili. Pokud jste mladší 15 let, je potřeba, aby souhlas udělil váš zákonný zástupce. V případě pochybností si můžeme vyžádat potvrzení o vašem věku."]
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsxs(_components.p, {
            children: ["Pokud ", _jsx(_components.strong, {
              children: "prostřednictvím souborů cookies"
            }), " dochází ke zpracování osobních údajů, tyto osobní údaje zpracováváme na základě a pro účely uzavření a plnění smlouvy (týká se pouze nezbytných cookies) nebo na základě vašeho souhlasu (který udělujete v příslušné liště umístěné na webovém rozhraní, přičemž bez tohoto souhlasu není možné tyto soubory cookies shromažďovat), a to zejména pro účely ", _jsx(_components.strong, {
              children: "provádění uživatelské podpory"
            }), ", ", _jsx(_components.strong, {
              children: "zlepšování našich služeb včetně analýzy chování uživatelů"
            }), " a ", _jsx(_components.strong, {
              children: "marketingu"
            }), "."]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.strong, {
          children: "Použít vaše osobní údaje k jinému účelu, než pro který byly získány, můžeme jen na základě vašeho souhlasu."
        })
      }), "\n", _jsxs(_components.p, {
        children: ["4.3. ", _jsx(_components.strong, {
          children: "Po jak dlouhou dobu údaje využíváme?"
        })]
      }), "\n", _jsx(_components.p, {
        children: "Osobní údaje zadané v rámci poptávání a objednávání zboží či služeb nebo v rámci registrace využíváme pouze po dobu nezbytnou pro splnění smlouvy a splnění právních povinností, resp. pro ochranu našich právních nároků."
      }), "\n", _jsx(_components.p, {
        children: "Pokud nám udělíte výslovný souhlas se zpracováním osobních údajů nebo pokud užíváme vaši e-mailovou adresu pro zasílání obchodních sdělení v souladu s předchozím článkem, budou údaje využity po dobu fungování webového rozhraní, na kterém budeme nabízet služby nebo zboží obdobné těm, které jste si od nás objednali, event. po dobu uvedenou v souhlasu."
      }), "\n", _jsx(_components.h2, {
        children: "5. Vaše práva v souvislosti s osobními údaji"
      }), "\n", _jsxs(_components.p, {
        children: ["5.1. ", _jsx(_components.strong, {
          children: "Právo na odvolání souhlasu se zpracováním osobních údajů"
        })]
      }), "\n", _jsx(_components.p, {
        children: "Pokud zpracováváme vaše osobní údaje jen na základě vašeho souhlasu (tj. bez jiného zákonného důvodu), můžete tento souhlas kdykoliv odvolat."
      }), "\n", _jsx(_components.p, {
        children: "Odvolání souhlasu se zpracováním vašich osobních údajů je možné kdykoliv, a to: − prostřednictvím e-mailu zaslaného na naši kontaktní e-mailovou adresu;"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["\n", _jsx(_components.p, {
            children: "telefonicky na našem kontaktním telefonním čísle;"
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsx(_components.p, {
            children: "písemně formou dopisu zaslaného na naši doručovací adresu;"
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsx(_components.p, {
            children: "u příslušných souborů cookies – v nastavení webového rozhraní nebo v nastavení vašeho internetového prohlížeče;"
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsx(_components.p, {
            children: "v případě obchodních sdělení – způsobem, který je uveden v každém e-mailu obsahujícím obchodní sdělení (kliknutím na odhlašovací odkaz nebo jiným způsobem)."
          }), "\n"]
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: "Odvoláním souhlasu není dotčena zákonnost zpracování údajů prováděného do doby odvolání souhlasu se zpracováním."
      }), "\n", _jsxs(_components.p, {
        children: ["5.2. ", _jsx(_components.strong, {
          children: "Právo na přístup k osobním údajům"
        })]
      }), "\n", _jsx(_components.p, {
        children: "Máte právo nás požádat o informaci, zda provádíme zpracování vašich osobních údajů. Pokud vaše údaje zpracováváme, máte právo na přístup k těmto osobním údajům a zejména k následujícím informacím:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["\n", _jsx(_components.p, {
            children: "účel zpracování;"
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsx(_components.p, {
            children: "kategorie zpracovávaných osobních údajů;"
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsx(_components.p, {
            children: "příjemci nebo kategorie příjemců, kterým budou osobní údaje zpřístupněny; − doba, po kterou budou osobní údaje uloženy."
          }), "\n"]
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: "Na vaši žádost vám poskytneme kopii zpracovávaných údajů. Za další kopie vám můžeme účtovat administrativní poplatek nepřevyšující náklady spojené s vyhotovením a předáním těchto dalších kopií."
      }), "\n", _jsxs(_components.p, {
        children: ["5.3. ", _jsx(_components.strong, {
          children: "Právo na opravu"
        })]
      }), "\n", _jsx(_components.p, {
        children: "Pokud jsou vaše osobní údaje nepřesné nebo neúplné, máte právo požadovat bezodkladnou nápravu, tj. opravu nepřesných údajů a/nebo doplnění neúplných údajů."
      }), "\n", _jsxs(_components.p, {
        children: ["5.4. ", _jsx(_components.strong, {
          children: "Právo vznést námitku proti zpracování"
        })]
      }), "\n", _jsx(_components.p, {
        children: "Máte právo kdykoliv vznést námitku proti zpracování vašich osobních údajů, pokud je zpracováváme pro účely přímého marketingu včetně jakéhokoliv automatizovaného zpracování osobních údajů. Po vznesení námitky přestaneme vaše osobní údaje pro tyto účely dále zpracovávat."
      }), "\n", _jsxs(_components.p, {
        children: ["5.5. ", _jsx(_components.strong, {
          children: "Právo na výmaz („právo být zapomenut“)"
        })]
      }), "\n", _jsx(_components.p, {
        children: "Máte právo požadovat, abychom vaše osobní údaje smazali, pokud:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["\n", _jsx(_components.p, {
            children: "osobní údaje již nejsou potřebné pro účely, pro které byly shromážděny nebo zpracovávány;"
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsx(_components.p, {
            children: "jste odvolali souhlas se zpracováním;"
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsx(_components.p, {
            children: "jste vznesli námitky proti zpracování osobních údajů;"
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsx(_components.p, {
            children: "osobní údaje byly zpracovávány protiprávně."
          }), "\n"]
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: "Pokud neexistují zákonné důvody pro odmítnutí vymazání, jsme povinni vaší žádosti vyhovět."
      }), "\n", _jsxs(_components.p, {
        children: ["5.6. ", _jsx(_components.strong, {
          children: "Právo na omezení zpracování"
        })]
      }), "\n", _jsx(_components.p, {
        children: "Máte právo požadovat, abychom omezili zpracování vašich osobních údajů, pokud: − popíráte přesnost svých osobních údajů;"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["\n", _jsx(_components.p, {
            children: "je zpracování protiprávní a vy namísto výmazu žádáte o omezení zpracování osobních údajů;"
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsx(_components.p, {
            children: "již vaše osobní údaje nepotřebujeme pro účely zpracování, ale vy je požadujete pro určení, výkon či obhajobu právních nároků;"
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsx(_components.p, {
            children: "vznesete námitku proti zpracování."
          }), "\n"]
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: "Při omezení zpracování jsme pouze oprávněni vaše osobní údaje uložit; další zpracování je možné jen s vaším souhlasem, nebo ze zákonných důvodů."
      }), "\n", _jsx(_components.p, {
        children: "Pokud je zpracování osobních údajů omezeno z důvodu námitky proti zpracování, trvá omezení po dobu nutnou pro zjištění, zda jsme povinni vaší námitce vyhovět."
      }), "\n", _jsx(_components.p, {
        children: "Pokud je zpracování osobních údajů omezeno z důvodu popření přesnosti údajů, trvá omezení po dobu ověření přesnosti údajů."
      }), "\n", _jsxs(_components.p, {
        children: ["5.7. ", _jsx(_components.strong, {
          children: "Právo na přenositelnost údajů"
        })]
      }), "\n", _jsx(_components.p, {
        children: "Máte právo na získání vašich osobních údajů, které jste nám poskytli, ve strukturovaném, běžně používaném a strojově čitelném formátu a jejich předání jinému správci osobních údajů."
      }), "\n", _jsxs(_components.p, {
        children: ["5.8. ", _jsx(_components.strong, {
          children: "Jak můžete svá práva uplatnit?"
        })]
      }), "\n", _jsx(_components.p, {
        children: "Vaše práva v souvislosti s osobními údaji můžete uplatnit prostřednictvím našich kontaktních údajů. Veškeré informace a úkony vám budou poskytnuty bez zbytečného odkladu."
      }), "\n", _jsxs(_components.p, {
        children: ["Při ochraně vašich osobních údajů vám vyjdeme maximálně vstříc. Pokud ovšem s vyřízením nebudete spokojeni, máte právo obrátit se na příslušné orgány, zejména na ", _jsx(_components.a, {
          href: "https://www.uoou.cz",
          children: "Úřad pro ochranu osobních údajů"
        }), ", který vykonává dozor nad ochranou osobních údajů. Tímto ustanovením není dotčeno vaše oprávnění obrátit se se svým podnětem na Úřad pro ochranu osobních údajů přímo."]
      }), "\n", _jsx(_components.p, {
        children: "Pokud se zejména vaše bydliště, místo výkonu zaměstnání nebo místo údajného porušení ochrany osobních údajů nachází mimo Českou republiku v jiném členském státě Evropské unie, můžete se obrátit na příslušný dozorový úřad v tomto členském státě."
      }), "\n", _jsx(_components.h2, {
        children: "6. Správa a zpracování osobních údajů"
      }), "\n", _jsxs(_components.p, {
        children: ["6.1. ", _jsx(_components.strong, {
          children: "Kdo vaše osobní údaje zpracovává?"
        })]
      }), "\n", _jsx(_components.p, {
        children: "Společnost Shania, a.s. je jako provozovatel správcem osobních údajů ve smyslu nařízení."
      }), "\n", _jsx(_components.p, {
        children: "V rozsahu, jaký je nutný pro splnění smlouvy nebo dalších povinností, jsme oprávněni vaše osobní údaje předávat i dalším osobám, např. dopravcům, dodavatelům cloudových úložišť, správcům e-mailových kampaní, společnosti poskytující certifikát „Ověřeno zákazníky“, externí účetní nebo dalším osobám podílejícím se na splnění smlouvy či našich povinností. Další zpracovatelé jsou např. spol Google, Facebook, Seznam. Případně můžeme pověřit i jiné zpracovatele a příjemce osobních údajů. Kdo konkrétně vaše osobní údaje zpracovává, vám sdělíme také na základě vašeho dotazu."
      }), "\n", _jsx(_components.p, {
        children: "Vaše osobní údaje nebudou předávány do států mimo Evropskou unii, ledaže to bude nezbytné pro plnění smlouvy nebo z jiného důvodu v souladu s pravidly takovéhoto předávání stanovenými nařízením."
      }), "\n", _jsxs(_components.p, {
        children: ["6.2. ", _jsx(_components.strong, {
          children: "Jak osobní údaje zpracováváme?"
        })]
      }), "\n", _jsx(_components.p, {
        children: "Osobní i další získávané údaje jsou plně zabezpečeny proti zneužití. Osobní údaje budou zpracovávány v elektronické podobě automatizovaným způsobem nebo v tištěné podobě neautomatizovaným způsobem."
      }), "\n", _jsx(_components.h2, {
        children: "7. Soubory cookies"
      }), "\n", _jsxs(_components.p, {
        children: ["7.1. ", _jsx(_components.strong, {
          children: "Co jsou to cookies?"
        })]
      }), "\n", _jsx(_components.p, {
        children: "Cookies jsou textové soubory ukládané do počítače nebo jiného elektronického zařízení každého návštěvníka webového rozhraní, které umožňují fungování webového rozhraní."
      }), "\n", _jsx(_components.p, {
        children: "Ne všechny cookies shromažďují osobní údaje; některé pouze umožňují správné fungování webového rozhraní. Používání souborů cookies můžete odmítnout volbou v příslušném nastavení v internetovém prohlížeči."
      }), "\n", _jsx(_components.p, {
        children: "Upozorňujeme na to, že při odmítnutí používání souborů cookies není vyloučeno, že nebudete moci plně využívat veškeré funkce webového rozhraní."
      }), "\n", _jsxs(_components.p, {
        children: ["7.2. ", _jsx(_components.strong, {
          children: "Jaké cookies a pro jaké účely je webové rozhraní využívá?"
        })]
      }), "\n", _jsxs(_components.p, {
        children: ["Webové rozhraní používá ", _jsx(_components.strong, {
          children: "relační (dočasné) cookies"
        }), ", které jsou automaticky mazány po ukončení prohlížení webového rozhraní. Dále využívá ", _jsx(_components.strong, {
          children: "trvalé cookies"
        }), ", které zůstávají ve vašem zařízení, dokud nedojde k jejich expiraci nebo dokud je nesmažete."]
      }), "\n", _jsx(_components.p, {
        children: "Cookies, které využívá webové rozhraní, jsou následující:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["\n", _jsxs(_components.p, {
            children: [_jsx(_components.strong, {
              children: "cookies první strany"
            }), " – tyto cookies jsou přiřazeny k doméně našeho webu; jedná se o nezbytné cookies a výkonnostní cookies, které využíváme pro uzavírání a plnění smlouvy (zejména nezbytné cookies), případně na základě výše uvedeného souhlasu. Tyto cookies mohou být dočasné nebo trvalé;"]
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsxs(_components.p, {
            children: [_jsx(_components.strong, {
              children: "nezbytné cookies"
            }), " – umožňují navigaci na webovém rozhraní a využívání základních funkcí, zpravidla vás nijak neidentifikují a nejedná se o osobní údaje;"]
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsxs(_components.p, {
            children: [_jsx(_components.strong, {
              children: "výkonnostní cookies"
            }), " – slouží pro analýzu způsobu využívání webového rozhraní (počet návštěv, čas strávený na webovém rozhraní apod.); údaje získané těmito cookies jsou zpravidla anonymní, ke shromažďování těchto souborů cookies dochází na základě vašeho souhlasu (který udělujete v příslušné liště umístěné na webovém rozhraní, přičemž bez tohoto souhlasu není možné tyto soubory cookies shromažďovat);"]
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsxs(_components.p, {
            children: [_jsx(_components.strong, {
              children: "cookies třetích stran"
            }), " – tyto cookies jsou přiřazeny k jiné doméně, než je doména našeho webu, a to i když se nacházíte na našem webu; tyto cookies nám na základě vašeho souhlasu (který udělujete v příslušné liště umístěné na webovém rozhraní, přičemž bez tohoto souhlasu není možné tyto soubory cookies shromažďovat) umožňují zejména analyzovat náš web a zobrazovat pro vás reklamu na míru; jedná se o funkční cookies a cílené a reklamní cookies;"]
          }), "\n", _jsxs(_components.ul, {
            children: ["\n", _jsxs(_components.li, {
              children: ["\n", _jsxs(_components.p, {
                children: [_jsx(_components.strong, {
                  children: "funkční cookies"
                }), " – slouží k personalizaci obsahu prostřednictvím zapamatování přihlašovacích údajů, geolokace apod.; jejich prostřednictvím může docházet k získávání a zpracování osobních údajů;"]
              }), "\n"]
            }), "\n", _jsxs(_components.li, {
              children: ["\n", _jsxs(_components.p, {
                children: [_jsx(_components.strong, {
                  children: "cílené a reklamní cookies"
                }), " – slouží k zobrazování cílených reklam na webovém rozhraní i mimo ně; jejich prostřednictvím může docházet k získávání a zpracování osobních údajů. Informace o tom, jak náš web využíváte, můžeme dále sdílet s našimi partnery z oblasti sociálních sítí, inzerce a analýz."]
              }), "\n", _jsxs(_components.p, {
                children: ["7.3. ", _jsx(_components.strong, {
                  children: "Používané služby pracující s cookies"
                })]
              }), "\n"]
            }), "\n"]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.p, {
        children: ["Webové rozhraní používá službu Google Analytics a případně i další služby poskytované společností Google LLC (dále jen „", _jsx(_components.strong, {
          children: "Google"
        }), "“), službu Facebook Pixel poskytovanou společností Facebook Inc. a službu Sklik poskytovanou společností Seznam.cz, a.s. Tyto služby pracují s informacemi získanými prostřednictvím souborů cookies."]
      }), "\n", _jsx(_components.p, {
        children: "Služba Google Analytics slouží k získání statistických informací o vašem užívání webového rozhraní. Soubory cookies získané touto službou expirují v závislosti na nastavení prohlížeče, nejvýše pak po 2 letech, popřípadě dokud nedojde k jejich manuálnímu odstranění z vaší strany."
      }), "\n", _jsx(_components.p, {
        children: "Služba Google Ads slouží k vaší identifikaci v rámci reklamní sítě společnosti Google a k opětovnému cílení reklamy (retargeting a remarketing). Soubory cookies získané touto službou expirují v závislosti na nastavení prohlížeče, nejvýše pak po 18 měsících, popřípadě dokud nedojde k jejich manuálnímu odstranění z vaší strany."
      }), "\n", _jsx(_components.p, {
        children: "Služba Facebook Pixel slouží k vaší identifikaci v rámci reklamní sítě společnosti Facebook Inc. a k opětovnému cílení reklamy (retargeting a remarketing). Soubory cookies získané touto službou expirují v závislosti na nastavení prohlížeče, nejvýše pak po 2 letech, popřípadě dokud nedojde k jejich manuálnímu odstranění z vaší strany."
      }), "\n", _jsx(_components.p, {
        children: "Služba Sklik.cz slouží k vaší identifikaci v rámci reklamní sítě společnosti Seznam.cz a k opětovnému cílení reklamy (retargeting a remarketing). Soubory cookies získané touto službou expirují v závislosti na nastavení prohlížeče, nejvýše pak po 18 měsících, popřípadě dokud nedojde k jejich manuálnímu odstranění z vaší strany."
      }), "\n", _jsx(_components.p, {
        children: "Pokud vás zajímá, jak Google využívá data, které od nás získává, a jak zpracování upravit nebo zakázat, dozvíte se tyto informace kliknutím na následující odkaz: **Jak Google využívá data, když používáte weby nebo aplikace našich partnerů. **"
      }), "\n", _jsxs(_components.p, {
        children: ["7.4. ", _jsx(_components.strong, {
          children: "Jak nastavit a případně odmítnout zpracování souborů cookies"
        })]
      }), "\n", _jsx(_components.p, {
        children: "Návod, jak správně nastavit a spravovat zpracování souborů cookies ve vašem internetovém prohlížeči, naleznete zde:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://support.google.com/accounts/answer/61416?hl=cs",
            children: "Google Chrome"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://support.microsoft.com/cs-cz/help/17442/windows-internet-explorer-delete-manage-cookies",
            children: "Internet Explorer"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://support.microsoft.com/cs-cz/help/4468242/microsoft-edge-browsing-data-and-privacy-microsoft-privacy",
            children: "Microsoft Edge"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://support.mozilla.org/cs/kb/vymazani-cookies-dat-stranek",
            children: "Mozilla Firefox"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://help.opera.com/cs/latest/web-preferences/#cookies",
            children: "Opera"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://support.apple.com/cs-cz/guide/safari/sfri11471/mac",
            children: "Safari"
          })
        }), "\n"]
      }), "\n", _jsx(_components.h2, {
        children: "8. Ochrana autorských práv"
      }), "\n", _jsx(_components.p, {
        children: "Obsah webových stránek umístěných na webovém rozhraní (texty, fotografie, obrázky, loga a další), včetně programového vybavení webového rozhraní a těchto podmínek, je chráněn naším autorským právem anebo autorskými a dalšími právy třetích osob. Obsah nesmíte měnit, kopírovat, rozmnožovat, šířit ani používat k jakémukoli účelu bez našeho souhlasu či souhlasu držitele autorských práv. Zejména je zakázáno bezplatné či úplatné zpřístupňování fotografií a textů umístěných na webovém rozhraní."
      }), "\n", _jsx(_components.p, {
        children: "Názvy a označení výrobků, zboží, služeb, firem a společností mohou být registrovanými obchodními známkami příslušných vlastníků."
      }), "\n", _jsxs(_components.p, {
        children: ["8.1. ", _jsx(_components.strong, {
          children: "Jakými způsoby budeme při porušení autorských práv postupovat?"
        })]
      }), "\n", _jsx(_components.p, {
        children: "Při nerespektování výše popsaného zákazu budeme postupovat v souladu se zákonem č. 121/2000 Sb., autorský zákon, ve znění pozdějších předpisů."
      }), "\n", _jsx(_components.p, {
        children: "Jako držitel autorských práv máme zejména právo domáhat se, aby bylo od zásahů do našich autorských práv upuštěno, a požadovat stažení neoprávněných kopií chráněného obsahu."
      }), "\n", _jsx(_components.p, {
        children: "Dále máme právo požadovat přiměřené zadostiučinění za způsobenou újmu."
      }), "\n", _jsx(_components.h2, {
        children: "9. Ostatní vztahy související s využíváním webového rozhraní"
      }), "\n", _jsxs(_components.p, {
        children: ["9.1. ", _jsx(_components.strong, {
          children: "Upozorňujeme vás na to, že kliknutím na některé odkazy na webovém rozhraní může dojít k opuštění webového rozhraní a k přesměrování na webové stránky třetích subjektů."
        })]
      }), "\n", _jsx(_components.p, {
        children: "9.2. Nemůžeme vám zaručit nepřerušený přístup na webové rozhraní, ani nezávadnost a bezpečnost webového rozhraní. Neodpovídáme za škodu způsobenou při realizaci přístupu a užívání webového rozhraní, včetně případné škody vzniklé při stahování dat zveřejněných na webovém rozhraní, škody způsobené přerušením provozu, poruchou webového rozhraní, počítačovými viry, škodu v důsledku ztráty dat, zisku nebo neoprávněného přístupu k přenosům a datům."
      }), "\n", _jsx(_components.p, {
        children: "9.3. Neneseme odpovědnost za chyby vzniklé v důsledku zásahů třetích osob do webového rozhraní nebo v důsledku jeho užití v rozporu s jeho určením. Při využívání webového rozhraní nesmíte používat mechanismy, programové vybavení, skripty nebo jiné postupy, které by mohly mít negativní vliv na jeho provoz, tj. především narušit funkci systému nebo nepřiměřeně zatěžovat systém, a dále nesmíte vykonávat žádnou činnost, která by mohla vám nebo třetím osobám umožnit neoprávněně zasahovat či neoprávněně užít programové vybavení nebo další součásti tvořící webové rozhraní a užívat webové rozhraní nebo jeho části či softwarové vybavení takovým způsobem, který by byl v rozporu s jeho určením či účelem."
      }), "\n", _jsx(_components.p, {
        children: "9.4. Pokud se při užívání webového rozhraní dopustíte jakéhokoliv nezákonného či neetického jednání, jsme oprávněni omezit, pozastavit nebo ukončit váš přístup na webové rozhraní, a to bez jakékoli náhrady. V tomto případě jste dále povinni uhradit nám škodu, která vaším jednáním dle tohoto odstavce prokazatelně vznikla, a to v plné výši."
      }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.p, {
        children: "Tyto podmínky užití jsou platné a účinné od 7. 7. 2022"
      })]
    });
  }
}
export default MDXContent;
